import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import Card from '@/common/components/Card';
import SelectInput from '@/common/components/SelectInput';
import useRecruitmentSearchBar from '../hooks/useRecruitmentSearchBar';
import { ButtonWrapper, SearchBar } from '../styles/Recruitment.styled';
import { Wrapper } from '../styles/RecruitmentSearchBar.styled';

const RecruitmentSearchBar = ({
	setShowCandidateForm,
	setVisibleCandidates,
	candidates,
}) => {
	const hook = useRecruitmentSearchBar({ setVisibleCandidates, candidates });

	return (
		<Card>
			<SearchBar>
				<Wrapper>
					<div style={{ display: 'flex' }}>
						<SelectInput
							options={hook.managerOptions}
							color={Colors.darkBlue}
							name='Manager'
							selectWidth={200}
							width={80}
							selected={hook.selectedManager}
							setSelected={hook.handleFilterManager}
						/>
						<SelectInput
							options={hook.marketOptions}
							color={Colors.darkBlue}
							name='Market'
							selectWidth={200}
							width={80}
							selected={hook.selectedMarket}
							setSelected={hook.handleFilterMarket}
						/>
					</div>
				</Wrapper>
				<Wrapper>
					<SelectInput
						name='Status'
						options={hook.statusOptions}
						color={Colors.darkBlue}
						selectWidth={200}
						width={80}
						selected={hook.selectedStatus}
						setSelected={hook.handleFilterStatus}
					/>
				</Wrapper>
				<ButtonWrapper>
					<ActionButton
						onClick={() => setShowCandidateForm(true)}
						defaultText='Add candidate'
					/>
				</ButtonWrapper>
			</SearchBar>
		</Card>
	);
};

export default RecruitmentSearchBar;
